import React from "react";
import useSWR, { mutate } from "swr";
import { faCheckCircle, faSquarePlus, faTimesCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Header, Loader, Toast } from "../../components";
import { Table } from "../../components/table/Table";
import { UserInfo } from "./components/UserInfo";
import { Modal } from "../../components/modal/Modal";
import { AddUser } from "./components/AddUser";
import { AXIOS } from "../../services/api";
import { useModal, useToast } from "../../hooks";
import styles from "./UsersPage.module.scss";

function UsersPage() {
    const { isOpen, openModal, closeModal } = useModal();
    const { toastInfo, showToast, clearToast } = useToast();
    const [searchQuery, setSearchQuery] = React.useState("");

    const { data, isLoading, error } = useSWR('users', AXIOS.get);
    const users = data?.data?.data || [];
    const hasUsers = users.length > 0;

    const defaultAvatar = 'https://tinyurl.com/3wxzu2ec';
    const columns = [
        {
            header: "User Info",
            accessor: "user-info",
            render: (row) => <UserInfo name={`${row.firstname} ${row.lastname}`} email={row.email}
                                       avatar={row?.avatar || defaultAvatar} />,
        },
        {
            header: "Verified",
            accessor: "user-verified",
            render: (row) => <FontAwesomeIcon icon={row.verified ? faCheckCircle : faTimesCircle}
                                              color={row.verified ? "green" : "red"} />,
        },
        {
            header: "Actions",
            accessor: "actions",
            render: (row) => (
                <Button label="Delete" icon={faTrash} variant="error" onClick={() => handleUserDeletion(row)} />
            ),
        }
    ];

    if (isLoading) return <Loader loading={isLoading} />;
    if (error) return <p>Error loading users: {error.message}</p>;

    const handleUserDeletion = async (row) => {
        AXIOS.delete(`/users/${row.id}`)
            .then(() => {
                mutate('users');
                showToast("User deleted successfully!", 'info');
            })
            .catch((error) => {
                showToast("User deletion failed", 'error');
            });
    };

    const handleUserCreation = () => {
        closeModal();
        mutate('users');
        showToast("User created successfully!", 'info');
    };

    const filteredUsers = users.filter(user =>
        `${user.firstname} ${user.lastname}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <>
            <div className={styles.addUser}>
                <Button
                    label="Add User"
                    icon={faSquarePlus}
                    variant="primary"
                    size="xl"
                    onClick={openModal}
                />
            </div>
            <div className={styles.userContainer}>
                <Table columns={columns} data={filteredUsers} />
            </div>

            <Modal show={isOpen} onClose={closeModal}>
                <AddUser onSubmit={handleUserCreation} onClose={closeModal} />
            </Modal>

            {toastInfo.message && <Toast message={toastInfo.message} type={toastInfo.type} onClose={clearToast} />}
        </>
    );
}

export { UsersPage };
